import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";

export default function SiteFooter() {
  const { t } = useT();
  return (
    <footer
      data-testid="site-footer"
      className="relative w-full border-t border-ink/15 px-6 md:px-10 py-10 bg-bone text-ink"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
        <div className="md:col-span-4">
          <p className="font-burnts text-6xl md:text-7xl leading-[1.05] py-[0.1em]">
            Rushit Shah<span className="text-crimson">.</span>
          </p>
        </div>

        <nav className="md:col-span-3" aria-label="Footer primary">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink/40 mb-3">{t("footer.index")}</p>
          <ul className="space-y-2 font-mono text-[11px] uppercase tracking-[0.2em]">
            <li><Link to="/works" className="link-underline">{t("nav.works")}</Link></li>
            <li><Link to="/exhibitions" className="link-underline">{t("nav.rooms")}</Link></li>
            <li><Link to="/about" className="link-underline">{t("nav.about")}</Link></li>
          </ul>
        </nav>

        <nav className="md:col-span-3" aria-label="Footer secondary">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink/40 mb-3">{t("footer.back_rooms")}</p>
          <ul className="space-y-2 font-mono text-[11px] uppercase tracking-[0.2em]">
            <li><Link to="/contact" data-testid="footer-letter-link" className="link-underline">{t("nav.letter")}</Link></li>
            <li><Link to="/privacy" className="link-underline">{t("nav.privacy")}</Link></li>
          </ul>
        </nav>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink/40 mb-3">{t("footer.elsewhere")}</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] leading-[1.9]">
            <a href="https://instagram.com/rushitshah08" target="_blank" rel="noreferrer" className="link-underline">Instagram ↗</a>
            <span className="mx-2 text-ink/40">·</span>
            <a href="https://www.artworkarchive.com/profile/rushitshah" target="_blank" rel="noreferrer" className="link-underline">Artwork Archive ↗</a>
          </p>
        </div>
      </div>

      <div className="mt-12 pt-5 border-t border-ink/10 flex items-center justify-between gap-3 font-mono text-[10px] tracking-[0.3em] uppercase text-ink/55">
        <p>{t("footer.rights", { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
}
